import React, { useRef, useEffect } from 'react';
import { fieldGroupStyle, labelStyle, helpTextStyle, sectionHeaderStyle } from './sharedStyles';

const UNIT_OPTIONS = [
  { value: 'both', label: 'quote_builder_widget.unit_option_both' },
  { value: 'mm', label: 'quote_builder_widget.unit_option_mm' },
  { value: 'in', label: 'quote_builder_widget.unit_option_in' },
];

const ConfigurationSection = ({
  domains,
  setDomains,
  unitOption,
  setUnitOption,
  addDomainFormVisible,
  setAddDomainFormVisible,
  addDomainFormHighlighted,
  setAddDomainFormHighlighted,
  newDomain,
  setNewDomain,
}) => {
  const domainInputRef = useRef();

  useEffect(() => {
    if (addDomainFormVisible && domainInputRef.current) {
      domainInputRef.current.focus();
    }
  }, [addDomainFormVisible]);

  const onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index;
  };

  const addToDomains = () => {
    if (newDomain.split('.').length === 1) {
      return;
    }
    setDomains((previous) => previous.concat([newDomain]).filter(onlyUnique));
    setAddDomainFormHighlighted(false);
    setAddDomainFormVisible(false);
    setNewDomain('');
  };

  const removeFromDomains = (domain) => {
    setDomains((previous) => previous.filter((d) => d !== domain));
  };

  const domainWithHttp = (domain) => `https://${domain}`;

  return (
    <div>
      <h4 style={sectionHeaderStyle}>
        {t('quote_builder_widget.section_configuration')}
      </h4>

      {/* Domains */}
      <div style={fieldGroupStyle}>
        <label style={labelStyle}>{t('quote_builder_widget.domains')}</label>
        <p style={helpTextStyle}>{t('quote_builder_widget.domains_info')}</p>

        <div style={addDomainFormHighlighted ? { padding: '15px', border: '1px solid #dc3545', borderRadius: '4px' } : {}}>
          {domains.length > 0 && (
            <div style={{ marginBottom: '10px' }}>
              {domains.map((domain) => (
                <div key={domain} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '6px' }}>
                  <span style={{ fontFamily: 'monospace', backgroundColor: '#f8f9fa', padding: '4px 8px', borderRadius: '4px' }}>
                    {domainWithHttp(domain)}
                  </span>
                  <button
                    type="button"
                    className="btn btn-sm"
                    style={{ color: '#dc3545', padding: '2px 8px' }}
                    onClick={() => removeFromDomains(domain)}
                  >
                    <i className="fa fa-trash-o" aria-hidden="true"></i> {t('quote_builder_widget.remove')}
                  </button>
                </div>
              ))}
            </div>
          )}

          {!addDomainFormVisible && (
            <button
              className="btn simple-btn"
              onClick={(event) => {
                event.preventDefault();
                setAddDomainFormVisible(true);
              }}
            >
              <i className="fa fa-plus-square-o" aria-hidden="true"></i> {t('quote_builder_widget.add_domain')}
            </button>
          )}

          {addDomainFormVisible && (
            <div className="form-inline" style={{ marginTop: '10px' }}>
              <div className="form-group">
                <div className="input-group">
                  <div className="input-group-addon">https://</div>
                  <input
                    type="text"
                    className="form-control"
                    size="35"
                    ref={domainInputRef}
                    value={newDomain}
                    placeholder="www.example.com"
                    onChange={(event) => setNewDomain(event.target.value)}
                  />
                </div>
              </div>
              <button type="button" className="btn simple-btn" onClick={addToDomains} style={{ marginLeft: '10px' }}>
                {t('quote_builder_widget.save')}
              </button>
              <button className="btn" type="button" onClick={() => setAddDomainFormVisible(false)} style={{ marginLeft: '5px' }}>
                {t('quote_builder_widget.cancel')}
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Unit Selection */}
      <div style={fieldGroupStyle}>
        <label style={labelStyle}>{t('quote_builder_widget.unit_option')}</label>
        <p style={helpTextStyle}>{t('quote_builder_widget.unit_option_info')}</p>
        <select
          className="form-control"
          value={unitOption}
          onChange={(event) => setUnitOption(event.target.value)}
          style={{ width: '250px' }}
        >
          {UNIT_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {t(option.label)}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ConfigurationSection;
